import React from 'react';
import { Button } from '@mui/material'; // or your preferred UI library
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    // Clear current session/local storage if needed
    localStorage.removeItem('authToken');
    // Redirect to login page
    navigate('/login');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Access Denied</h1>
        <div style={styles.icon}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#DC3545" strokeWidth="2"/>
            <path d="M12 8V12" stroke="#DC3545" strokeWidth="2" strokeLinecap="round"/>
            <path d="M12 16H12.01" stroke="#DC3545" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        <p style={styles.message}>
          You don't have permission to access this asset.
        </p>
        <p style={styles.suggestion}>
          Would you like to try logging in with a different account?
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLoginRedirect}
          style={styles.button}
        >
          Switch Account
        </Button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center'
  },
  title: {
    color: '#DC3545',
    marginBottom: '20px'
  },
  icon: {
    marginBottom: '20px',
    color: '#DC3545'
  },
  message: {
    fontSize: '18px',
    marginBottom: '10px',
    color: '#212529'
  },
  suggestion: {
    fontSize: '16px',
    marginBottom: '30px',
    color: '#6C757D'
  },
  button: {
    padding: '10px 24px',
    fontWeight: 'bold'
  }
};

export default AccessDeniedPage;